var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"title":`Abonnement ${_vm.subscription.title } ändern`,"name":"settings-payment-subscription-edit"}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('SettingsPaymentSubscriptionForm',{attrs:{"type":"edit","subscription":_vm.subscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }